import { Injectable, signal } from '@angular/core';

const MOBILE_BREAKPOINT = 768;

@Injectable({
  providedIn: 'root',
})
export class AppLayoutService {
  private readonly _mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);

  isMobile = signal(this._mql.matches);
  isSidebarVisible = signal(!this.isMobile());
  isDrawerVisible = signal(false);

  constructor() {
    this._mql.addEventListener('change', (e) => {
      this.isMobile.set(e.matches);
    });
  }

  toggle(): void {
    if (this.isMobile()) {
      this.isDrawerVisible.update(v => !v);
    } else {
      this.isSidebarVisible.update(v => !v);
    }
  }
}
